module.exports = __webpack_public_path__ + "img/p1-bg.c4e655e5.png";